import { BRAND } from "@/core/constants/cirxConstants";
import { addUserBodyClass } from "@/core/services/bodyModificator";
import { getCurrentDomain } from "@/core/services/domain.service";
import { cloneDeep } from "@/core/utils/utils";
import { useLayoutConfigStore } from "@/core/store/config/configStore";
import useAccountStore from "@/apps/shared/organization/store/accountStore";
import useTranslate from "@/core/composables/translate";
import defaultLayout from "@/core/config/layoutConfig";
import useHeaderButtonStore from "@/core/store/headerButton/headerButtonStore";
import { DASHBOARD_WIZARD, DASHBOARD_DEFAULT, PUBLIC_WIZARD } from "@/core/constants/layout";

const { translate } = useTranslate();
export const buybackWizardDashboardLayout = {
  ...cloneDeep(defaultLayout),

  subheader: {
    ...defaultLayout.subheader,
    display: false,
  },
};

export const buybackWizardPublicLayout = {
  ...cloneDeep(defaultLayout),

  subheader: {
    ...defaultLayout.subheader,
    display: false,
  },

  header: {
    ...defaultLayout.header,

    user: {
      display: false,
    },

    menu: {
      self: {
        display: false,
      },
    },
  },

  aside: {
    ...defaultLayout.aside,

    self: {
      display: false,
    },
  },

  content: {
    ...defaultLayout.content,
    width: "fluid",
  },
};

export const setDashboardLayout = (layoutType) => {
  const configStore = useLayoutConfigStore();
  switch (layoutType) {
    case PUBLIC_WIZARD:
      configStore.setLayoutConfig(buybackWizardPublicLayout);
      break;
    case DASHBOARD_WIZARD:
      configStore.setLayoutConfig(buybackWizardDashboardLayout);
      break;
    case DASHBOARD_DEFAULT:
      configStore.resetLayoutConfig();
      break;
    default:
      configStore.resetLayoutConfig();
      break;
  }

  // reset action button in subheader
  useHeaderButtonStore().resetHeaderActions();

  // Scroll page to top on every route change
  window.scrollTo(0, 0);
};

export const setCustomLayoutByOrganization = (isDashboardApp = false) => {
  const { name, mainColor, logo, favicon } = useAccountStore();
  if (!mainColor || !logo) {
    return;
  }

  const customizedConfig = cloneDeep(isDashboardApp ? defaultLayout : buybackWizardPublicLayout);
  customizedConfig.self.logo.default = logo;
  customizedConfig.self.logo.png = logo;
  customizedConfig.colors.theme.base.primary = mainColor;
  useLayoutConfigStore().setLayoutConfig(customizedConfig);

  if (name) {
    updateMetaTags(name, isDashboardApp);
  }

  if (favicon) {
    const faviconElement = document.getElementById("favicon");
    faviconElement.href = favicon;
  }

  addUserBodyClass();
};

export const resetCustomLayoutOnLogout = () => {
  const configStore = useLayoutConfigStore();
  document.title = BRAND;
  const favicon = document.getElementById("favicon");
  favicon.href = `${process.env.VUE_APP_URL}/favicon.ico`;
  configStore.resetLayoutConfig();
};

export const updateMetaTags = (name, isDashboard = false, title = null, description = null) => {
  const localeEntry = isDashboard ? "DASHBOARD_DOC_TITLE" : "PUBLIC_DOC_TITLE";

  if (!title) {
    title = translate(`TAGS.HOME.${localeEntry}`, {
      organizationName: name,
    });
  }
  document.title = title;
  document.querySelector('meta[name="twitter:title"]').setAttribute("content", title);
  document.querySelector('meta[property="og:title"]').setAttribute("content", title);

  if (!description) {
    description = translate(`TAGS.HOME.DESCRIPTION`);
  }
  document.querySelector('meta[name="description"]').setAttribute("content", description);
  document.querySelector('meta[property="og:description"]').setAttribute("content", description);
  document.querySelector('meta[name="twitter:description"]').setAttribute("content", description);

  const url = getCurrentDomain();
  document.querySelector('meta[property="og:url"]').setAttribute("content", url);
  document.querySelector('meta[name="twitter:url"]').setAttribute("content", url);
};

export const getCustomMainColor = () => {
  const configStore = useLayoutConfigStore();
  const { mainColor } = useAccountStore();
  return mainColor || configStore.getLayoutConfig("colors.theme.base.primary");
};

export const getOrganizationLogo = () => {
  const { logo } = useAccountStore();
  const configStore = useLayoutConfigStore();
  return logo || configStore.getLayoutConfig("self.logo.default") || configStore.getLayoutConfig("self.logo.png");
};

export const layoutService = {
  getOrganizationLogo,
};
